import { Dropdown, IDropdownOption } from "@fluentui/react";
import { RootState } from "app/store";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ICESDropdownProps } from "./ICESDropdownProps.type";
import * as FAM from "model/FlexibleAttributeModel";

const CESDropdown: React.FunctionComponent<ICESDropdownProps> = (props) => {

    const state = useSelector((state: RootState) => state);

    const options = useMemo(() => {

        const cesNumbers = state.data.json.groupStructure.cesNumbers;

        const options: IDropdownOption<FAM.ICESNumber>[] = [];

        cesNumbers.forEach(ea => {
            const t = {
                key: ea.id,
                text: ea.cesNumber ?? '',
                data: ea,
                hidden: ea.deactivated
            };
            options.push(t);
        })

        return options;

    }, [
        state.data.json.groupStructure.cesNumbers
    ]);

    return <Dropdown
        label={"CES Client Number"}
        options={options}
        selectedKey={props.value?.id ?? undefined}
        onChange={(event, option) => {
            props.onChange(option?.data as FAM.ICESNumber)
        }}
    />
}

export default CESDropdown;